import { render } from "./KeyboardComponent.vue?vue&type=template&id=2241cdea"
import script from "./KeyboardComponent.vue?vue&type=script&lang=js"
export * from "./KeyboardComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__